import { Component, Inject, OnChanges, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-picker-dialog',
    templateUrl: './app-picker-dialog.component.html',
    styleUrls: ['./app-picker-dialog.component.scss'],
    providers: [],
    standalone: false
})
export class AppPickerDialogComponent implements OnInit {
  public selectedApps = new Map();
  public availableCompositionApps: Models.CompositionApp[] = [];
  public availableDynamicContent: Models.DynamicContentEntrance[] = [];
  public availableCodeSnippets: Models.CodeSnippet[] = [];
  public availableApps: any[] = [];

  constructor(public dialogRef: MatDialogRef<AppPickerDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.availableApps = this.data?.availableApps || this.availableApps;
    this.availableCompositionApps = this.data?.availableCompositionApps || this.availableCompositionApps;
    this.availableDynamicContent = this.data?.availableDynamicContent || this.availableDynamicContent;
    this.availableCodeSnippets = this.data?.availableCodeSnippets || this.availableCodeSnippets;
    if (!this.availableApps.length && (this.availableCompositionApps || this.availableDynamicContent || this.availableCodeSnippets)) {
      this.availableApps = [...(this.availableCompositionApps || []), ...(this.availableCodeSnippets || []), ...(this.availableDynamicContent || [])];
    }
  }

  public onSelectedChange(event: MatCheckboxChange, app: any): void {
    if (!event.checked) {
      this.selectedApps.delete(app._id);
      return;
    }

    this.selectedApps.set(app._id, app);
  }

  public onSubmit(): void {
    const selectedApps = [];
    this.selectedApps.forEach(app => {
      selectedApps.push(app);
    });
    this.dialogRef.close(selectedApps);
  }

}
